import appLocaleData from 'react-intl/locale-data/zh';
import chMessages from '../locales/zh-HK';

const ChLang = {
    messages: {
        ...chMessages
    },
    locale: 'zh-HK',
    data: appLocaleData
};
export default ChLang;